<template>
  <div class="app">
    <Header v-if="!showNavbar && !$store.getters.isApp" :left-hide="leftHide" :title="headerInfo.title" />

    <div :class="['app-main', { 'has-header': !showNavbar }]">
      <VuePageStack>
        <router-view />
      </VuePageStack>
    </div>

    <ActivedDialog />
    <AgreementDialog />
    <KYCDialog />
    <AddCardDialog />
    <ErrorDialog />
    <AccountStatusError />
  </div>
</template>

<script>
import Header from '@/components/Header'
import ActivedDialog from '@/components/ActivedDialog'
import AgreementDialog from '@/components/AgreementDialog'
import KYCDialog from '@/components/KYCDialog'
import AddCardDialog from '@/components/AddCardDialog'
import ErrorDialog from '@/components/ErrorDialog'
import AccountStatusError from '@/components/AccountStatusError'

export default {
  name: 'APP',

  components: {
    Header,
    ActivedDialog,
    AgreementDialog,
    KYCDialog,
    AddCardDialog,
    ErrorDialog,
    AccountStatusError
  },

  computed: {
    headerInfo () {
      return this.$route.meta || {}
    },
    showNavbar () {
      if (this.$route.path === '/') return true // HACK 初始进入时候会有闪烁
      return this.$route.meta && this.$route.meta.navHide
    },
    leftHide () {
      return this.$route.meta && this.$route.meta.leftHide
    }
  }
}
</script>

<style scoped lang="scss">
.app {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.app-main {
  overflow: auto;
  height: 100%;
  -webkit-overflow-scrolling: touch;

  &.has-header {
    min-height: calc(100% - 88px);
  }

  &.no-header {
    height: 100%;
  }
}

.md-button {
  position: fixed;
  top: 30px;
  right: 30px;
  z-index: 200;
}
</style>
